module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/institutions/icon_round-arrow-left-79c45bede6e45e533637fea1222e11aa.svg";